module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "system-builder__main-upgrades--container"
  }, [_c('div', {
    staticClass: "system-builder__main-upgrades--wrapper"
  }, _vm._l((_vm.sharedState.accessories), function(accessory, index) {
    return (_vm.checkCompatibility(accessory.model_number)) ? _c('upgradeItem', {
      attrs: {
        "upgradeKey": index,
        "isActive": accessory.selected,
        "id": accessory.ID
      }
    }, [_c('div', {
      slot: "upgrade-image"
    }, [_c('img', {
      attrs: {
        "src": accessory.images.image.url,
        "alt": accessory.images.image.alt
      }
    })]), _vm._v(" "), _c('div', {
      slot: "upgrade-description"
    }, [_c('strong', [_vm._v(_vm._s(accessory.post_title))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(accessory.description)
      }
    })])]) : _vm._e()
  })), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "system-builder__main-upgrades--bottom-nav"
  }, [_c('div', {
    staticClass: "skip-link",
    on: {
      "click": _vm.goToViewSystem
    }
  }, [_vm._v("skip")]), _vm._v(" "), (_vm.sharedState.steps.selectUpgrades.passedValidation) ? _c('footerNav') : _vm._e()], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ee4dba5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/steps/SelectUpgrades.vue
// module id = 429
// module chunks = 1